import React, { useState, useEffect, useRef } from "react";
import { ChevronIcon } from "../../icons/chevron/ChevronIcon";
import styles from "./truncatable.css";

interface Props {
  maxHeight: number;
  className?: string;
  initialIsOpen?: boolean;
}
const enum CollapseState {
  NothingToExpand,
  Collapsed,
  Expanded
}
export const Truncatable = ({
  maxHeight,
  className,
  initialIsOpen,
  children
}: React.PropsWithChildren<Props>) => {
  const [state, setState] = useState(CollapseState.NothingToExpand);
  // tslint:disable-next-line:no-null-keyword
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const determineState = () => {
      const { current: el } = ref;
      if (!el) {
        setState(CollapseState.NothingToExpand);
      } else if (el.scrollHeight <= maxHeight) {
        setState(CollapseState.NothingToExpand);
      } else if (el.scrollHeight === el.offsetHeight || initialIsOpen) {
        setState(CollapseState.Expanded);
      } else {
        setState(CollapseState.Collapsed);
      }
    };
    determineState();
  }, [ref.current]);

  const renderExpandingControls = () => {
    switch (state) {
      case CollapseState.NothingToExpand:
        return;
      case CollapseState.Collapsed:
        return (
          <div
            className={styles["expand-section"]}
            onClick={() => setState(CollapseState.Expanded)}
          >
            <ChevronIcon clickable pointing="down" className={styles["expand-icon"]} />
          </div>
        );
      case CollapseState.Expanded:
        return (
          <div
            className={styles["expand-section"]}
            onClick={() => setState(CollapseState.Collapsed)}
          >
            <ChevronIcon clickable pointing="up" className={styles["expand-icon"]} />
          </div>
        );
      default:
        return;
    }
  };

  return (
    <div className={className}>
      <div
        className={styles.truncateable}
        ref={ref}
        style={{ maxHeight: state === CollapseState.Expanded ? "100%" : maxHeight }}
      >
        {children}
      </div>
      {renderExpandingControls()}
    </div>
  );
};
